import store from "@/store";

export default class LoadingUtils{

  static start(){
    store.commit('setLoading', true)
  }

  static end(){
    store.commit('setLoading', false)
  }

  static loding(){
    return store.getters.loading
  }
}
